'use client';

import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import LinkIcon from '@mui/icons-material/Link';
import { Box, IconButton, Typography } from '@mui/material';

import { Avatar } from '@/components';
import type { EventResponse } from '@/types';

interface DesktopMarketHeaderProps {
  event: EventResponse;
  formattedTotalVolume: string;
  resolutionDate: string;
  isBookmarked: boolean;
  onBookmarkClick: () => void;
  onShareClick: () => void;
}

export function DesktopMarketHeader({
  event,
  formattedTotalVolume,
  resolutionDate,
  isBookmarked,
  onBookmarkClick,
  onShareClick,
}: DesktopMarketHeaderProps) {
  const finalResolutionDate = resolutionDate == 'Invalid Date' ? '' : resolutionDate;
  return (
    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: 2,
          mb: 1.5,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
          <Avatar
            src={event?.icon || event?.image}
            alt={event?.title || 'Market'}
            size={48}
            sx={{ borderRadius: 2 }}
          />
          <Typography
            variant="h4"
            fontWeight={700}
            sx={{
              fontSize: '2rem',
              wordBreak: 'break-word',
              width: '100%',
              lineHeight: 1.2,
            }}
          >
            {event?.title || '-'}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
          <IconButton size="small" title="Copy link" onClick={onShareClick}>
            <LinkIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            title="Bookmark"
            sx={{
              color: isBookmarked ? 'primary.main' : 'inherit',
              transition: 'color 0.2s ease',
              '&:hover': {
                color: isBookmarked ? 'primary.dark' : 'inherit',
              },
            }}
            onClick={onBookmarkClick}
          >
            {isBookmarked ? (
              <BookmarkIcon fontSize="small" />
            ) : (
              <BookmarkBorderIcon fontSize="small" />
            )}
          </IconButton>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
          {formattedTotalVolume} Vol.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
          {finalResolutionDate}
        </Typography>
      </Box>
    </Box>
  );
}
